import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFolder = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		d: "m11.75 5.75-2-3h-6a2 2 0 0 0-2 2v1m10 0h4.5a2 2 0 0 1 2 2v7.5a2 2 0 0 1-2 2H3.75a2 2 0 0 1-2-2v-9.5m10 0h-10"
	})]
});
const ForwardRef = forwardRef(SvgFolder);
export { ForwardRef as ReactComponent };
